import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Guard against missing env vars so the portal still renders in dev without
// a .env.local. Live fetchers will return empty; pages fall back to static
// content. In production both values are set via Vercel.
export const supabaseConfigured = Boolean(supabaseUrl && supabaseKey);

export const supabase = supabaseConfigured
  ? createClient(supabaseUrl, supabaseKey)
  : createNoopClient();

function createNoopClient() {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-console
    console.warn('[portal] Supabase env vars missing (REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY). Falling back to static content.');
  }
  const noResult = { data: null, error: new Error('supabase-not-configured') };
  const chain = {
    select: () => chain,
    eq: () => chain,
    is: () => chain,
    order: () => chain,
    limit: () => chain,
    maybeSingle: () => Promise.resolve(noResult),
    single: () => Promise.resolve(noResult),
    then: (onFulfilled, onRejected) => Promise.resolve(noResult).then(onFulfilled, onRejected),
  };
  return {
    from: () => chain,
    rpc: () => Promise.resolve(noResult),
  };
}
